import StBlock from './StBlock';

/**
 * Display property with get/set declarations and implementations
 */
const PropertyBlock = ({ property }) => {
  return (
    <div className="declaration-implementation-block">
      {property.name && <h3>{property.name}</h3>}
      <StBlock code={property.declaration} />
      {(property.getDeclaration || property.getImplementation) && (
        <>
          <h4>Get</h4>
          <hr />
          <StBlock code={property.getDeclaration} />
          <hr />
          <StBlock code={property.getImplementation} />
        </>
      )}
      {(property.setDeclaration || property.setImplementation) && (
        <>
          <h4>Set</h4>
          <hr />
          <StBlock code={property.setDeclaration} />
          <hr />
          <StBlock code={property.setImplementation} />
        </>
      )}
    </div>
  );
};

export default PropertyBlock;
